import { render, staticRenderFns } from "./TerminationService.vue?vue&type=template&id=30937b9c&scoped=true&"
import script from "./TerminationService.vue?vue&type=script&lang=js&"
export * from "./TerminationService.vue?vue&type=script&lang=js&"
import style0 from "./TerminationService.vue?vue&type=style&index=0&id=30937b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30937b9c",
  null
  
)

export default component.exports